import React, { useState } from "react";
import { Link as RouterLink } from "react-router-dom";

import {
  Collapse,
  List,
  ListItemIcon,
  MenuItem,
  Tooltip,
  Typography,
} from "@material-ui/core";
import { ExpandMore } from "@material-ui/icons";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  icon: { minWidth: theme.spacing(5) },
  sidebarIsOpen: {
    "& a": {
      paddingLeft: theme.spacing(4),
      transition: "padding-left 195ms cubic-bezier(0.4, 0, 0.6, 1) 0ms",
    },
  },
  sidebarIsClosed: {
    "& a": {
      paddingLeft: theme.spacing(2),
      transition: "padding-left 195ms cubic-bezier(0.4, 0, 0.6, 1) 0ms",
    },
  },
}));

export const SubMenu = ({
  sidebarIsOpen,
  name,
  icon,
  dense,
  defaultTo,
  children,
  onClick,
}) => {
  const classes = useStyles();
  const [isOpen, setIsOpen] = useState(false);

  const handleTitleClick = (e) => {
    if (defaultTo) {
      // if they provided a 'defaultTo', we navigate there
      // but still call the onClick toggle to close the sidebar
      onClick?.(e);
    }
    setIsOpen((prev) => !prev);
  };

  const TitleComponent = defaultTo ? RouterLink : "div";

  const header = (
    <MenuItem
      dense={dense}
      button
      component={TitleComponent}
      to={defaultTo}
      onClick={handleTitleClick}
    >
      <ListItemIcon className={classes.icon}>
        {isOpen ? <ExpandMore /> : icon}
      </ListItemIcon>
      <Typography variant="inherit" color="textSecondary">
        {name}
      </Typography>
    </MenuItem>
  );

  return (
    <>
      {sidebarIsOpen || isOpen ? (
        header
      ) : (
        <Tooltip title={name} placement="right">
          {header}
        </Tooltip>
      )}
      <Collapse in={isOpen} timeout="auto" unmountOnExit>
        <List
          dense={dense}
          component="div"
          disablePadding
          className={
            sidebarIsOpen ? classes.sidebarIsOpen : classes.sidebarIsClosed
          }
        >
          {children}
        </List>
      </Collapse>
    </>
  );
};
